import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { CarDetailsQueryKeys } from "modules/CarDetails/queryKeys";
import { ApiInstance } from "utils/Api";

const handleDeleteCarNoteOnAppointment = (noteId: number) => {
  const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
  if (!appointment?.car?.notes?.length) return;

  const appointmentCarNoteIdx = appointment.car.notes.findIndex(note => note.id === noteId);
  if (appointmentCarNoteIdx === -1) return;

  typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
    ...appointment,
    car: { ...appointment.car, notes: appointment.car.notes.toSpliced(appointmentCarNoteIdx, 1) }
  });
};

const handleDeleteCarNoteOnCar = (noteId: number) => {
  const car = typedQueryClient.getQueryData(CarDetailsQueryKeys.details);
  if (!car?.notes?.length) return;

  const carNoteIdx = car.notes.findIndex(note => note.id === noteId);
  if (carNoteIdx === -1) return;

  typedQueryClient.setQueryData(CarDetailsQueryKeys.details, { ...car, notes: car.notes.toSpliced(carNoteIdx, 1) });
};

export const useDeleteCarNoteMutation = () =>
  useTypedMutation<number, void>({
    mutationFn: async id => {
      await ApiInstance.post("/notes/delete", { car_note_id: id }, ENV.carBaseURL);
    },
    onSuccess: noteId => {
      handleDeleteCarNoteOnCar(noteId);
      handleDeleteCarNoteOnAppointment(noteId);
    }
  });
